import { useBreakpoint } from 'gatsby-plugin-breakpoints';
import { GatsbyImage } from 'gatsby-plugin-image';
import { merge } from 'lodash';
import React from 'react';
import { Container } from 'react-bootstrap';
import { CMS_THEME } from 'src/common/enums';
import { StorageContentBlock } from '../common/StorageContentBlock/StorageContentBlock';
import { HotspotDialog } from './components/HotspotDialog';
import { HotspotPopover } from './components/HotspotPopover';
import { TStorageHotspots } from './types';

interface StorageHotspotsProps {
  node: TStorageHotspots;
}

const DefaultSettings = {
  entity_heading: {
    element: 'h2',
    style: 'typography_h2',
  },
  entity_subheading: {
    element: 'h3',
    style: 'typography_h3',
  },
  entity_buttons: {
    primary_button: 'btn',
  },
  entity_variant: {
    text_align: 'center',
    theme: CMS_THEME.LIGHT,
  },
};

const StorageHotspots: React.FC<StorageHotspotsProps> = ({ node: hotspots }) => {
  const settings = merge({}, DefaultSettings, hotspots?.behaviors);
  const mainImage =
    hotspots.relationships.field_hotspots_media.relationships.field_media_image.gatsbyImage;
  const markerMedia = hotspots.relationships.field_marker_asset;
  const points = hotspots.field_hotspots_markers;
  const breakPoint = useBreakpoint();
  const isSSR = typeof window === 'undefined';

  return (
    <div data-id={hotspots.drupal_id}>
      <Container>
        <div className="pds-my-4.5 pds-w-full">
          <StorageContentBlock
            node={{
              title: hotspots.field_title,
              body: hotspots.field_text,
              subtitle: hotspots.field_subtitle,
              behaviors: settings as any,
            }}
          />
        </div>
        <figure className="pds-relative">
          <div className="pds-full" style={{ transformOrigin: 'top left' }}>
            <GatsbyImage
              alt={hotspots.relationships.field_hotspots_media.field_media_image.alt}
              aria-hidden="true"
              objectFit="contain"
              image={mainImage}
            />
          </div>
          {/* TODO: this needs to be a new field to describe the purpose that the whole thing is being used for */}
          <figcaption className="pds-sr-only">
            {hotspots.relationships.field_hotspots_media.field_media_image.alt}
          </figcaption>
          <div className="pds-absolute pds-left-0 pds-top-0 pds-block pds-h-full pds-w-full">
            {/* Popover Implements forceMount for crawlers / Dialog does not. */}
            {isSSR || breakPoint.md
              ? points.map((point, index) => {
                  return (
                    <HotspotPopover
                      key={hotspots.relationships.field_hotspots_markers[index].name}
                      point={point}
                      markerContent={hotspots.relationships.field_hotspots_markers[index]}
                      markerMedia={markerMedia}
                    />
                  );
                })
              : points.map((point, index) => {
                  return (
                    <HotspotDialog
                      key={hotspots.relationships.field_hotspots_markers[index].name}
                      point={point}
                      markerContent={hotspots.relationships.field_hotspots_markers[index]}
                      markerMedia={markerMedia}
                    />
                  );
                })}
          </div>
        </figure>
      </Container>
    </div>
  );
};

export default StorageHotspots;
